import { WSElement, WSElementProps } from "@wingspanhq/fe-component-library";
import classNames from "classnames";
import React from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryActivities } from "../../../query/users/queries";
import styles from "./index.module.scss";
import { selectorIsWhilteLabeled } from "./selectorIsWhilteLabeled";
import { selectorLogoData } from "./selectorLogoData";
import { useCustomization } from "../../../modules/customization";

type Props = { small?: boolean } & WSElementProps;

export const LogoApp: React.FC<Props> = ({
  className,
  small,
  ...elementProps
}) => {
  const userId = useUserId();
  const { branding } = useCustomization();
  const activityQuery = useQueryActivities(userId);

  const customizingSmallLogo =
    branding(false)?.secondaryLogoUrl || branding(false)?.primaryLogoUrl;

  const logoData = customizingSmallLogo
    ? {
        src: customizingSmallLogo,
        alt: branding(false)?.name
      }
    : selectorLogoData(activityQuery.data);

  return (
    <WSElement
      as={"img"}
      {...logoData}
      className={classNames(
        styles.logo,
        {
          [styles.whiteLabeled]: selectorIsWhilteLabeled(activityQuery.data),
          [styles.small]: small
        },
        className
      )}
      {...elementProps}
    />
  );
};
